import { Component } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { combineLatest } from 'rxjs';
import { CpReportsScaleService } from './cp-reports-scale.service';
import { UtilsService } from '@library/utils/services/utils.service';

@Component({
  selector: 'app-cp-reports-scale-selector',
  templateUrl: './cp-reports-scale-selector.component.html',
  styleUrls: ['./cp-reports-scale-selector.component.scss']
})
export class CpReportsScaleSelectorComponent {

  viewModel$ = combineLatest({
    scale: this.cpReportsScaleService.scale$
  });

  scales = [
    {value: EnumScales.MONTH_DAILY, label: 'common-app.__MONTHLY'},
    {value: EnumScales.YEAR, label: 'common-app.__YEARLY'}
  ];

  EnumScales = EnumScales;

  constructor(
    public utilsService: UtilsService,
    private cpReportsScaleService: CpReportsScaleService,
  ) {
  }

  ngOnInit() {
    // init scale with month
    this.cpReportsScaleService.setScale(EnumScales.MONTH_DAILY);
  }

  scaleLabel(scale: EnumScales) {
    return this.scales.find(s => s.value === scale)?.label;
  }

  setScale(scale: EnumScales) {
    this.cpReportsScaleService.setScale(scale);
  }

  scaleIndex(scale: EnumScales) {
    return this.scales.findIndex(s => s.value === scale);
  }

}
